import React, { useEffect, useState } from "react";
import getBooking from "../../../../controllers/booking/getBooking";
import { FareRulesModal } from "../../../../components/modal/FareRulesModal.jsx";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { enqueueSnackbar } from "notistack";
import getFlightOfferFarerule from "../../../../controllers/Flight/getOfferFarerule";

function TicketManagementConfirmationFareRules({ data, defaultBooking }) {
  const [booking, setBooking] = useState(defaultBooking);
  const flightBooking = data?.flightBooking;
  const [formattedFareRules, setFormattedFareRules] = useState();
  const [openFareRules, setOpenFareRules] = useState(false);
  const [loading, setLoading] = useState(false);

  const formattedExists = (rules) => {
    return rules && Object.keys(rules).length > 0;
  };

  const loadBooking = async () => {
    if (booking) return;
    // if (formattedExists(flightBooking?.formattedFareRules)) return;
    const res = await getBooking(flightBooking?.bookingId);
    if (res?.return) {
      setBooking(res?.data);
    }
  };

  useEffect(() => {
    if (formattedExists(flightBooking?.formattedFareRules)) {
      setFormattedFareRules(flightBooking?.formattedFareRules);
    }
  }, [flightBooking?.bookingId]);

  useEffect(() => {
    loadBooking();
  }, [flightBooking]);

  const handleFareRules = async () => {
    if (!booking?.fareRules && !formattedExists(formattedFareRules)) return;
    if (formattedExists(formattedFareRules)) {
      setOpenFareRules(true);
      return;
    }
    setLoading(true);
    const res = await getFlightOfferFarerule({
      flightBookingId: flightBooking?._id,
      segments: flightBooking?.flights?.map((flight) => ({
        segmentRef: flight?.segmentRef,
        departureLocation: flight?.departureLocation,
        departureLocationName: flight?.departureLocationName,
        arrivalLocation: flight?.arrivalLocation,
        arrivalLocationName: flight?.arrivalLocationName,
      })),
      fareRules: booking?.fareRules,
    }).finally(() => setLoading(false));
    if (res?.return) {
      const data = res?.data;
      setFormattedFareRules(data);
      setOpenFareRules(true);
    } else {
      enqueueSnackbar(
        res?.msg ||
          "Something went wrong when fetching fare rules. Please try again later!",
        { variant: "error" }
      );
    }
  };

  if (
    !booking?.fareRules &&
    !formattedExists(flightBooking?.formattedFareRules)
  )
    return <></>;

  return (
    <div className="flex items-center justify-between pt-4">
      <FareRulesModal
        open={openFareRules}
        setOpen={setOpenFareRules}
        fareRules={booking?.fareRules}
        formattedFareRules={formattedFareRules}
      />
      <button
        className="text-sm text-primary1 flex items-center gap-1 hover:underline"
        disabled={loading}
        onClick={() => handleFareRules()}
      >
        <AiOutlineInfoCircle className="w-4 h-4" />
        {loading ? (
          <div className="primaryLoader"></div>
        ) : (
          <>Fare rules & restrictions</>
        )}
      </button>

      {/* You will plug your modal here */}
      {/* Example:
        {openFareRules && (
          <FareRulesModal
            open={openFareRules}
            onClose={() => setOpenFareRules(false)}
          />
        )}
        */}
    </div>
  );
}

export default TicketManagementConfirmationFareRules;
